import { Box, FormControl, Grid, InputLabel, MenuItem, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  dismissLoader,
  showLoader,
  showSuccessMessage,
  updateScreenTitle,
} from "../../../LayoutContainers/AppLayout/redux/AppSlice";
import LayoutCard from "../../../Components/LayoutCard";
import { Field, Form, Formik } from "formik";
import WDBox from "../../../MaterialComponents/WDBox";
import WDButton from "../../../MaterialComponents/WDButton";
import FileField from "../../Common/Ticket/NewTicket/panels/FileField";
import { title } from "process";
import AppService from "../../../Configurations/Appservice";
import { useLocation } from "react-router-dom";
import uuid from "react-uuid";

const initialValues = {
  uid: "",
  address: "",
  area: "",
  birthCertificate: "", //doc
  birthPlaceAr: "",
  birthPlaceEn: "",
  buildingNumber: "",
  deliveryNumber: "",
  dob: "",
  email: "",
  emirate: "",
  emiratesId: "",
  emiratesIdExpiryDate: "",
  emiratesIdIssueDate: null,
  fileNumber: "",
  firstNameAr: "",
  firstNameEn: "",
  gender: null, //list
  landNumber: "",
  labourContract: "", //doc
  lastNameAr: "",
  lastNameEn: "",
  middleNameAr: "",
  middleNameEn: "",
  mobileNumber: "",
  nameAr: "",
  nameEn: "",
  passportCopy: "", //doc
  passportExpiry: null,
  passportIssue: null,
  passportIssuePlaceAr: "",
  passportIssuePlaceEn: "",
  passportNumber: "",
  photo: "", //image
  poBox: "",
  salaryCertificate: "", //doc
  shinasnama: "", //doc
  visaPage: "", //doc
  visaNumber: "",
  visaType: "",
  visaIssueDate: null,
  visaExpiryDate: null,
  visaSponsorName: "",
};

export default function NewUID(props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const formikRef = useRef();

  const [formData, setFormData] = useState(initialValues);

  useEffect(() => {
    dispatch(updateScreenTitle("New UID Entry"));
    return () => dispatch(updateScreenTitle());
  }, []);

  useEffect(() => {
    const id = location.state?.id;
    if (id) {
      dispatch(showLoader());
      AppService.get("v1/uid/details", { params: { id } })
        .then((response) => {
          console.log(response);
          setFormData(response);
        })
        .catch(() => {})
        .finally(() => {
          dispatch(dismissLoader());
        });
    }
  }, []);

  function onKeyDown(keyEvent) {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  }

  const _onSubmit = (values, { resetForm }) => {
    dispatch(showLoader());
    AppService.post("v1/uid", values)
      .then((response) => {
        dispatch(showSuccessMessage("UID Added"));
      })
      .catch(() => {})
      .finally(() => {
        dispatch(dismissLoader());
      });
  };

  return (
    <LayoutCard>
      <Formik
        initialValues={formData}
        enableReinitialize
        onSubmit={_onSubmit}
        // validationSchema={validationSchema}
        innerRef={formikRef}
      >
        {({ errors, isValid, touched, dirty, setFieldValue, values, setFieldTouched }) => (
          <Form onKeyDown={onKeyDown}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <WDBox>
                  <Field
                    name="uid"
                    label="UID"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.newPassword) && Boolean(touched.newPassword)}
                    helperText={Boolean(touched.newPassword) && errors.newPassword}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="address"
                    label="Address"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.address) && Boolean(touched.address)}
                    helperText={Boolean(touched.address) && errors.address}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="area"
                    label="Area"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.area) && Boolean(touched.area)}
                    helperText={Boolean(touched.area) && errors.area}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                {/* <WDBox>
                  <Field
                    name="birthCertificate"
                    label="Birth Certificate"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.birthCertificate) && Boolean(touched.birthCertificate)}
                    helperText={Boolean(touched.birthCertificate) && errors.birthCertificate}
                  />
                </WDBox> */}
                <WDBox height="100%">
                  <FileField
                    // index={0}
                    field={{
                      value: values.birthCertificate,
                      title: "Birth Certificate",
                      type: "PDF",
                    }}
                    onFileUpload={(response, field, index) =>
                      setFieldValue("birthCertificate", response)
                    }
                    onFileRemove={() => setFieldValue("birthCertificate", null)}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="birthPlaceAr"
                    label="Birth Place (Arabic)"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.birthPlaceAr) && Boolean(touched.birthPlaceAr)}
                    helperText={Boolean(touched.birthPlaceAr) && errors.birthPlaceAr}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="birthPlaceEn"
                    label="Birth Place (English)"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.birthPlaceEn) && Boolean(touched.birthPlaceEn)}
                    helperText={Boolean(touched.birthPlaceEn) && errors.birthPlaceEn}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="buildingNumber"
                    label="Building Number"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.buildingNumber) && Boolean(touched.buildingNumber)}
                    helperText={Boolean(touched.buildingNumber) && errors.buildingNumber}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="deliveryNumber"
                    label="Delivery Number"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.deliveryNumber) && Boolean(touched.deliveryNumber)}
                    helperText={Boolean(touched.deliveryNumber) && errors.deliveryNumber}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="dob"
                    label="Date of Birth"
                    fullWidth
                    as={TextField}
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    error={Boolean(errors.dob) && Boolean(touched.dob)}
                    helperText={Boolean(touched.dob) && errors.dob}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="email"
                    label="Email"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.email) && Boolean(touched.email)}
                    helperText={Boolean(touched.email) && errors.email}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="emirate"
                    label="Emirate"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.emirate) && Boolean(touched.emirate)}
                    helperText={Boolean(touched.emirate) && errors.emirate}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="emiratesId"
                    label="Emirates ID"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.emiratesId) && Boolean(touched.emiratesId)}
                    helperText={Boolean(touched.emiratesId) && errors.emiratesId}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="emiratesIdExpiryDate"
                    label="Emirates ID Expiry Date"
                    fullWidth
                    as={TextField}
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    error={
                      Boolean(errors.emiratesIdExpiryDate) && Boolean(touched.emiratesIdExpiryDate)
                    }
                    helperText={
                      Boolean(touched.emiratesIdExpiryDate) && errors.emiratesIdExpiryDate
                    }
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="emiratesIdIssueDate"
                    label="Emirates ID Issue Date"
                    fullWidth
                    as={TextField}
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    error={
                      Boolean(errors.emiratesIdIssueDate) && Boolean(touched.emiratesIdIssueDate)
                    }
                    helperText={Boolean(touched.emiratesIdIssueDate) && errors.emiratesIdIssueDate}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="fileNumber"
                    label="File Number"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.fileNumber) && Boolean(touched.fileNumber)}
                    helperText={Boolean(touched.fileNumber) && errors.fileNumber}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="firstNameAr"
                    label="First Name (Arabic)"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.firstNameAr) && Boolean(touched.firstNameAr)}
                    helperText={Boolean(touched.firstNameAr) && errors.firstNameAr}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="firstNameEn"
                    label="First Name (English)"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.firstNameEn) && Boolean(touched.firstNameEn)}
                    helperText={Boolean(touched.firstNameEn) && errors.firstNameEn}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="gender"
                    label="Gender"
                    fullWidth
                    as={TextField}
                    select
                    options={[
                      { value: "male", label: "Male" },
                      { value: "female", label: "Female" },
                    ]}
                    error={Boolean(errors.gender) && Boolean(touched.gender)}
                    helperText={Boolean(touched.gender) && errors.gender}
                  />
                </WDBox>
              </Grid>

              {/* <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="labourContract"
                    label="Labour Contract"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.labourContract) && Boolean(touched.labourContract)}
                    helperText={Boolean(touched.labourContract) && errors.labourContract}
                  />
                </WDBox>
              </Grid> */}

              <Grid item xs={3}>
                <WDBox height="100%">
                  <FileField
                    // index={0}
                    field={{
                      value: values.labourContract,
                      title: "Labour Contract",
                      type: "PDF",
                    }}
                    onFileUpload={(response, field, index) =>
                      setFieldValue("labourContract", response)
                    }
                    onFileRemove={() => setFieldValue("labourContract", null)}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="landNumber"
                    label="Landline Number"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.landNumber) && Boolean(touched.landNumber)}
                    helperText={Boolean(touched.landNumber) && errors.landNumber}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="lastNameAr"
                    label="Last Name (Arabic)"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.lastNameAr) && Boolean(touched.lastNameAr)}
                    helperText={Boolean(touched.lastNameAr) && errors.lastNameAr}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="lastNameEn"
                    label="Last Name (English)"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.lastNameEn) && Boolean(touched.lastNameEn)}
                    helperText={Boolean(touched.lastNameEn) && errors.lastNameEn}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="middleNameAr"
                    label="Middle Name (Arabic)"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.middleNameAr) && Boolean(touched.middleNameAr)}
                    helperText={Boolean(touched.middleNameAr) && errors.middleNameAr}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="middleNameEn"
                    label="Middle Name (English)"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.middleNameEn) && Boolean(touched.middleNameEn)}
                    helperText={Boolean(touched.middleNameEn) && errors.middleNameEn}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="mobileNumber"
                    label="Mobile Number"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.mobileNumber) && Boolean(touched.mobileNumber)}
                    helperText={Boolean(touched.mobileNumber) && errors.mobileNumber}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="nameAr"
                    label="Name (Arabic)"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.nameAr) && Boolean(touched.nameAr)}
                    helperText={Boolean(touched.nameAr) && errors.nameAr}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="nameEn"
                    label="Name (English)"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.nameEn) && Boolean(touched.nameEn)}
                    helperText={Boolean(touched.nameEn) && errors.nameEn}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                {/* <WDBox>
                  <Field
                    name="passportCopy"
                    label="Passport Copy"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.passportCopy) && Boolean(touched.passportCopy)}
                    helperText={Boolean(touched.passportCopy) && errors.passportCopy}
                  />
                </WDBox> */}

                <WDBox height="100%">
                  <FileField
                    // index={0}
                    field={{
                      value: values.passportCopy,
                      title: "Passport Copy",
                      type: "PDF",
                    }}
                    onFileUpload={(response, field, index) =>
                      setFieldValue("passportCopy", response)
                    }
                    onFileRemove={() => setFieldValue("passportCopy", null)}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="passportExpiry"
                    label="Passport Expiry Date"
                    fullWidth
                    as={TextField}
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    error={
                      Boolean(errors.passportExpiryDate) && Boolean(touched.passportExpiryDate)
                    }
                    helperText={Boolean(touched.passportExpiryDate) && errors.passportExpiryDate}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="passportIssue"
                    label="Passport Issue Date"
                    fullWidth
                    as={TextField}
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    error={Boolean(errors.passportIssueDate) && Boolean(touched.passportIssueDate)}
                    helperText={Boolean(touched.passportIssueDate) && errors.passportIssueDate}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="passportIssuePlaceEn"
                    label="Passport Issue Place (English)"
                    fullWidth
                    as={TextField}
                    error={
                      Boolean(errors.passportIssuePlaceEn) && Boolean(touched.passportIssuePlaceEn)
                    }
                    helperText={
                      Boolean(touched.passportIssuePlaceEn) && errors.passportIssuePlaceEn
                    }
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="passportIssuePlaceAr"
                    label="Passport Issue Place (Arabic)"
                    fullWidth
                    as={TextField}
                    error={
                      Boolean(errors.passportIssuePlaceAr) && Boolean(touched.passportIssuePlaceAr)
                    }
                    helperText={
                      Boolean(touched.passportIssuePlaceAr) && errors.passportIssuePlaceAr
                    }
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="passportNumber"
                    label="Passport Number"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.passportNumber) && Boolean(touched.passportNumber)}
                    helperText={Boolean(touched.passportNumber) && errors.passportNumber}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                {/* <WDBox>
                  <Field
                    name="photo"
                    label="Personal Photo"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.personalPhoto) && Boolean(touched.personalPhoto)}
                    helperText={Boolean(touched.personalPhoto) && errors.personalPhoto}
                  />
                </WDBox> */}

                <WDBox height="100%">
                  <FileField
                    // index={0}
                    field={{
                      value: values.photo,
                      title: "Photo",
                      type: "IMAGE",
                    }}
                    onFileUpload={(response, field, index) => setFieldValue("photo", response)}
                    onFileRemove={() => setFieldValue("photo", null)}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="poBox"
                    label="PO Box"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.poBox) && Boolean(touched.poBox)}
                    helperText={Boolean(touched.poBox) && errors.poBox}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                {/* <WDBox>
                  <Field
                    name="salaryCertificate"
                    label="Salary Certificate"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.salaryCertificate) && Boolean(touched.salaryCertificate)}
                    helperText={Boolean(touched.salaryCertificate) && errors.salaryCertificate}
                  />
                </WDBox> */}

                <WDBox height="100%">
                  <FileField
                    // index={0}
                    field={{
                      value: values.salaryCertificate,
                      title: "Salary Certificate",
                      type: "PDF",
                    }}
                    onFileUpload={(response, field, index) =>
                      setFieldValue("salaryCertificate", response)
                    }
                    onFileRemove={() => setFieldValue("salaryCertificate", null)}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                {/* <WDBox>
                  <Field
                    name="shinasnama"
                    label="Shinasnama"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.shinasnama) && Boolean(touched.shinasnama)}
                    helperText={Boolean(touched.shinasnama) && errors.shinasnama}
                  />
                </WDBox> */}
                <WDBox height="100%">
                  <FileField
                    // index={0}
                    field={{
                      value: values.shinasnama,
                      title: "Shinsama",
                      type: "PDF",
                    }}
                    onFileUpload={(response, field, index) => setFieldValue("shinasnama", response)}
                    onFileRemove={() => setFieldValue("shinasnama", null)}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                {/* <WDBox>
                  <Field
                    name="visaPage"
                    label="Visa Page"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.visaPage) && Boolean(touched.visaPage)}
                    helperText={Boolean(touched.visaPage) && errors.visaPage}
                  />
                </WDBox> */}
                <WDBox height="100%">
                  <FileField
                    // index={0}
                    field={{
                      value: values.visaPage,
                      title: "Visa Page",
                      type: "PDF",
                    }}
                    onFileUpload={(response, field, index) => setFieldValue("visaPage", response)}
                    onFileRemove={() => setFieldValue("visaPage", null)}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="visaNumber"
                    label="Visa Number"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.visaNumber) && Boolean(touched.visaNumber)}
                    helperText={Boolean(touched.visaNumber) && errors.visaNumber}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="visaType"
                    label="Visa Type"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.visaType) && Boolean(touched.visaType)}
                    helperText={Boolean(touched.visaType) && errors.visaType}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="visaIssueDate"
                    label="Visa Issue Date"
                    fullWidth
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    as={TextField}
                    error={Boolean(errors.visaIssueDate) && Boolean(touched.visaIssueDate)}
                    helperText={Boolean(touched.visaIssueDate) && errors.visaIssueDate}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="visaExpiryDate"
                    label="Visa Expiry Date"
                    fullWidth
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    as={TextField}
                    error={Boolean(errors.visaExpiryDate) && Boolean(touched.visaExpiryDate)}
                    helperText={Boolean(touched.visaExpiryDate) && errors.visaExpiryDate}
                  />
                </WDBox>
              </Grid>

              <Grid item xs={3}>
                <WDBox>
                  <Field
                    name="visaSponsorName"
                    label="Visa Sponsor Name"
                    fullWidth
                    as={TextField}
                    error={Boolean(errors.visaSponsorName) && Boolean(touched.visaSponsorName)}
                    helperText={Boolean(touched.visaSponsorName) && errors.visaSponsorName}
                  />
                </WDBox>
              </Grid>
            </Grid>
            <WDBox display="flex" justifyContent="flex-end" pt={3}>
              <WDButton variant="gradient" disabled={!dirty || !isValid} type="submit">
                Submit
              </WDButton>
            </WDBox>
          </Form>
        )}
      </Formik>
    </LayoutCard>
  );
}
